import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./Home";
import BookingDetail from "./BookingDetail";
import TrainerDetail from "./TrainerDetail";

class VPTDashboard extends React.Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route exact={true} path="/vpt" component={Home} />
            <Route path="/vpt/booking" component={BookingDetail} />
            <Route path="/vpt/trainer" component={TrainerDetail} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default VPTDashboard;